(function($) {
	'use strict';

	/**
	 * Group control titles by standard
	 * 
	 * This function processes data from the Combined structure and groups control titles
	 * by their standard ID. It extracts appropriate mappings (CRF for modern, CCC for legacy)
	 * for each control title and organizes them in a hierarchical structure.
	 * 
	 * @param {Object} data - The data object containing Combined structure
	 * @returns {Object} Object with structure: {standardid: {controltitle: {crfmappings: [array]}}}
	 */
	function groupControlTitlesByStandard(data) {
		// Initialize the resulting object to group by standardid
		const groupedControlTitles = {};

		// Check if data contains the expected structure
		if (!data.Combined) {
			console.error(`Data structure is not as expected.`);
			return groupedControlTitles;
		}

		// Determine if this is a modern or legacy assessment
		const assessmentYear = window.WebAssessmentCharts?.assessmentYear || "2025";
		const isModernAssessment = (assessmentYear === "2024" || assessmentYear === "2025" || assessmentYear === "2026");
		const mappingField = isModernAssessment ? 'crfmapping' : 'cccmapping';
		
		console.log(`[groupControlTitlesByStandard] Assessment year: ${assessmentYear}, Using: ${mappingField}`);

		// Iterate through the data
		data.Combined.forEach(item => {
			// Process each relatedCSItem
			if (item.relatedCSItems && Array.isArray(item.relatedCSItems)) {
				item.relatedCSItems.forEach(csItem => {
					const { standardid, controltitle } = csItem;
					const mapping = csItem[mappingField]; // Use appropriate mapping field

					// Ensure required fields are available
					if (standardid && controltitle && mapping) {
						// If the standardid doesn't exist in the grouped object, initialize it
						if (!groupedControlTitles[standardid.S]) {
							groupedControlTitles[standardid.S] = {};
						}

						// If the controltitle doesn't exist under the current standardid, initialize it
						if (!groupedControlTitles[standardid.S][controltitle.S]) {
							groupedControlTitles[standardid.S][controltitle.S] = {
								crfmappings: []
							};
						}

						// Split the mapping field by newlines to get individual mappings
						const mappings = mapping.S.split('\n').map(m => m.trim()).filter(m => m);

						// Add the mappings to the controltitle entry, avoiding duplicates
						groupedControlTitles[standardid.S][controltitle.S].crfmappings.push(...mappings);
						groupedControlTitles[standardid.S][controltitle.S].crfmappings =
							[...new Set(groupedControlTitles[standardid.S][controltitle.S].crfmappings)]; // Remove duplicates
					}
				});
			}
		});

		// Debug logging
		const fcaData = groupedControlTitles['FCA-RM-2024'];
		if (fcaData) {
			const sampleTitle = Object.keys(fcaData)[0];
			const sampleMappings = fcaData[sampleTitle]?.crfmappings || [];
			console.log(`[groupControlTitlesByStandard] FCA-RM-2024 found with ${Object.keys(fcaData).length} control titles`);
			console.log(`[groupControlTitlesByStandard] Sample mappings from "${sampleTitle}":`, sampleMappings.slice(0, 5));
		}

		return groupedControlTitles;
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = { groupControlTitlesByStandard };
	} else if (typeof window !== 'undefined') {
		window.groupControlTitlesByStandard = groupControlTitlesByStandard;
	}

})(jQuery);
